import { render } from "./ProfileFolloweeContent.vue?vue&type=template&id=72621df4&scoped=true"
import script from "./ProfileFolloweeContent.vue?vue&type=script&lang=js"
export * from "./ProfileFolloweeContent.vue?vue&type=script&lang=js"

import "./ProfileFolloweeContent.vue?vue&type=style&index=0&id=72621df4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72621df4"]])

export default __exports__